import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      &:hover {\n        > [role='tooltip'] {\n          display: block;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { css } from "@emotion/react";
var TooltipWrapper = /*#__PURE__*/ styled("div", {
    target: "e1q14i5o0"
})("position:relative;", function(param) {
    var hover = param.hover;
    return hover && css(_templateObject());
});
var TooltipContent = /*#__PURE__*/ styled("div", {
    target: "e1q14i5o1"
})("min-width:", function(param) {
    var $width = param.$width;
    return $width === "wide" ? "31.25rem" : "20rem";
}, ";max-width:31.25rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";padding:1rem;border:2px solid ", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";border-radius:0.75rem;position:absolute;font-weight:normal;font-size:0.875rem;z-index:100;transform:", function(param) {
    var $offset = param.$offset;
    return "translate(calc(-50% + ".concat($offset, "px), 15px)");
}, ";display:", function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, ";a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}&::before{content:'';position:absolute;width:100%;left:0;top:-20px;height:20px;}&::after{content:'';position:absolute;width:20px;height:20px;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";margin-bottom:-9px;margin-left:-10px;bottom:100%;left:50%;transform:rotate(-135deg);border-width:0 2px 2px 0;border-style:solid;border-color:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";border-image:none;border-top:0;border-left:0;}");
export { TooltipWrapper, TooltipContent };
